import {
  DEFAULT_PROFILE_SECTION,
  LEGACY_TAB_SECTIONS,
  profilePath,
} from './sections';
import { Navigate, useSearchParams } from 'react-router';

/**
 * `/profil` → `/profil/<sekcia>`.
 *
 * Sekcia bola do redizajnu záložkou v `?tab=`, takže holé `/profil` aj staré
 * `?tab=` adresy vedú sem. Prekladajú sa, lebo na ne ukazujú odkazy
 * v rozposlaných e-mailoch a push notifikáciách; zvyšok dopytu
 * (`transactionId`, `highlight-ids`) sa nesie ďalej nezmenený.
 */
const ProfileRedirect = () => {
  const [searchParams] = useSearchParams();

  const params = new URLSearchParams(searchParams);
  const tab = params.get('tab');
  params.delete('tab');

  const section = (tab && LEGACY_TAB_SECTIONS[tab]) || DEFAULT_PROFILE_SECTION;
  const search = params.toString();

  return (
    <Navigate
      replace
      to={`${profilePath(section)}${search ? `?${search}` : ''}`}
    />
  );
};

export default ProfileRedirect;
